import React from 'react';
import NotFound from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/not-found';

const NotFoundTastic = () => {
  return <NotFound />;
};

export default NotFoundTastic;
